import { ShortTextRounded as ShortTextRoundedIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import is from '@sindresorhus/is';
import { useContext } from 'react';

import { CardPlaceholder } from './common/CardPlaceholder';
import { ApplicationContext } from '../../../../../../shared/source/context/context';
import {
    ContentDetails,
    ContentHeadline,
    ContentWrapper,
} from '../../../../design/components/containers/ContentWrapper';
import { useOneUserQuery } from '../../../query-hooks/users';

import type { FunctionComponent, ReactNode } from 'react';

type AboutMeContentProps = {
    readonly aboutMe?: string | undefined;
    readonly actions?: ReactNode;
};

export const AboutMeContent: FunctionComponent<AboutMeContentProps> = ({ aboutMe: content, actions }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <ContentWrapper>
            <Box id="about-me" sx={{ position: 'relative', top: -75 }} />
            <ContentHeadline actions={actions} text={translate('pages.recruiter-profile.about-me.title')} />
            <ContentDetails>
                {is.nonEmptyString(content) ? (
                    <Typography variant="body1" whiteSpace="pre-line">
                        {content}
                    </Typography>
                ) : (
                    <CardPlaceholder
                        placeholderIcon={<ShortTextRoundedIcon />}
                        placeholderText={translate('pages.recruiter-profile.about-me.placeholder')}
                    />
                )}
            </ContentDetails>
        </ContentWrapper>
    );
};

type AboutMeProps = {
    readonly actions?: ReactNode;
    readonly userId: string;
};

export const AboutMe: FunctionComponent<AboutMeProps> = ({ actions, userId }) => {
    const { userQuery } = useOneUserQuery(userId);
    const aboutMe = userQuery.data?.aboutMe;

    return <AboutMeContent aboutMe={aboutMe} actions={actions} />;
};
